module.exports = __webpack_public_path__ + "img/sort-blue.27a4ea78.svg";